webpackJsonp([226383347778272],{

/***/ 275:
/***/ (function(module, exports) {

	module.exports = function() {
		return /[\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2604\u260E\u2611\u2614\u2615\u2618\u261D\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2648-\u2653\u2660\u2663\u2665\u2666\u2668\u267B\u267F\u2692-\u2694\u2696\u2697\u2699\u269B\u269C\u26A0\u26A1\u26AA\u26AB\u26B0\u26B1\u26BD\u26BE\u26C4\u26C5\u26C8\u26CE\u26CF\u26D1\u26D3\u26D4\u26E9\u26EA\u26F0-\u26F5\u26F7-\u26FA\u26FD\u2702\u2705\u2708-\u270D\u270F\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763\u2764\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC04\uDCCF\uDD70\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDE01\uDE02\uDE1A\uDE2F\uDE32-\uDE3A\uDE50\uDE51\uDF00-\uDF21\uDF24-\uDF93\uDF96\uDF97\uDF99-\uDF9B\uDF9E-\uDFF0\uDFF3-\uDFF5\uDFF7-\uDFFF]|\uD83D[\uDC00-\uDCFD\uDCFF-\uDD3D\uDD49-\uDD4E\uDD50-\uDD67\uDD6F\uDD70\uDD73-\uDD79\uDD87\uDD8A-\uDD8D\uDD90\uDD95\uDD96\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDEF\uDDF3\uDDFA-\uDE4F\uDE80-\uDEC5\uDECB-\uDED0\uDEE0-\uDEE5\uDEE9\uDEEB\uDEEC\uDEF0\uDEF3]|\uD83E[\uDD10-\uDD18\uDD80-\uDD84\uDDC0]|\uD83C\uDDFF\uD83C[\uDDE6\uDDF2\uDDFC]|\uD83C\uDDFE\uD83C[\uDDEA\uDDF9]|\uD83C\uDDFD\uD83C\uDDF0|\uD83C\uDDFC\uD83C[\uDDEB\uDDF8]|\uD83C\uDDFB\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDEE\uDDF3\uDDFA]|\uD83C\uDDFA\uD83C[\uDDE6\uDDEC\uDDF2\uDDF8\uDDFE\uDDFF]|\uD83C\uDDF9\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDED\uDDEF-\uDDF4\uDDF7\uDDF9\uDDFB\uDDFC\uDDFF]|\uD83C\uDDF8\uD83C[\uDDE6-\uDDEA\uDDEC-\uDDF4\uDDF7-\uDDF9\uDDFB\uDDFD-\uDDFF]|\uD83C\uDDF7\uD83C[\uDDEA\uDDF4\uDDF8\uDDFA\uDDFC]|\uD83C\uDDF6\uD83C\uDDE6|\uD83C\uDDF5\uD83C[\uDDE6\uDDEA-\uDDED\uDDF0-\uDDF3\uDDF7-\uDDF9\uDDFC\uDDFE]|\uD83C\uDDF4\uD83C\uDDF2|\uD83C\uDDF3\uD83C[\uDDE6\uDDE8\uDDEA-\uDDEC\uDDEE\uDDF1\uDDF4\uDDF5\uDDF7\uDDFA\uDDFF]|\uD83C\uDDF2\uD83C[\uDDE6\uDDE8-\uDDED\uDDF0-\uDDFF]|\uD83C\uDDF1\uD83C[\uDDE6-\uDDE8\uDDEE\uDDF0\uDDF7-\uDDFB\uDDFE]|\uD83C\uDDF0\uD83C[\uDDEA\uDDEC-\uDDEE\uDDF2\uDDF3\uDDF5\uDDF7\uDDFC\uDDFE\uDDFF]|\uD83C\uDDEF\uD83C[\uDDEA\uDDF2\uDDF4\uDDF5]|\uD83C\uDDEE\uD83C[\uDDE8-\uDDEA\uDDF1-\uDDF4\uDDF6-\uDDF9]|\uD83C\uDDED\uD83C[\uDDF0\uDDF2\uDDF3\uDDF7\uDDF9\uDDFA]|\uD83C\uDDEC\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEE\uDDF1-\uDDF3\uDDF5-\uDDFA\uDDFC\uDDFE]|\uD83C\uDDEB\uD83C[\uDDEE-\uDDF0\uDDF2\uDDF4\uDDF7]|\uD83C\uDDEA\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDED\uDDF7-\uDDFA]|\uD83C\uDDE9\uD83C[\uDDEA\uDDEC\uDDEF\uDDF0\uDDF2\uDDF4\uDDFF]|\uD83C\uDDE8\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDEE\uDDF0-\uDDF5\uDDF7\uDDFA-\uDDFF]|\uD83C\uDDE7\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEF\uDDF1-\uDDF4\uDDF6-\uDDF9\uDDFB\uDDFC\uDDFE\uDDFF]|\uD83C\uDDE6\uD83C[\uDDE8-\uDDEC\uDDEE\uDDF1\uDDF2\uDDF4\uDDF6-\uDDFA\uDDFC\uDDFD\uDDFF]|[#\*0-9]\u20E3/g;
	};


/***/ }),

/***/ 311:
/***/ (function(module, exports, __webpack_require__) {

	var emoji = __webpack_require__(275)
	
	module.exports = BananaSlug
	
	function BananaSlug () {
	  var self = this
	  if (!(self instanceof BananaSlug)) return new BananaSlug()
	
	  self.reset()
	}
	
	/**
	 * Generate a unique slug.
	 * @param  {string} value String of text to slugify
	 * @param  {boolean} [false] Keep the current case, otherwise make all lowercase
	 * @return {string}       A unique slug string
	 */
	BananaSlug.prototype.slug = function (value, maintainCase) {
	  maintainCase = maintainCase === true
	  var self = this
	  var slug = slugger(value, maintainCase)
	  var occurrences = self.occurrences[slug]
	
	  if (self.occurrences.hasOwnProperty(slug)) {
	    occurrences++
	  } else {
	    occurrences = 0
	  }
	
	  self.occurrences[slug] = occurrences
	
	  if (occurrences) {
	    slug = slug + '-' + occurrences
	  }
	
	  return slug
	}
	
	/**
	 * Reset - Forget all previous slugs
	 * @return void
	 */
	BananaSlug.prototype.reset = function () {
	  this.occurrences = {}
	}
	
	var whitespace = /\s/g
	
	function lower (string) {
	  return string.toLowerCase()
	}
	
	function slugger (string, maintainCase) {
	  var re = /[\u2000-\u206F\u2E00-\u2E7F\\'!"#$%&()*+,./:;<=>?@[\]^`{|}~]/g
	  var replacement = '-'
	
	  if (typeof string !== 'string') return ''
	  if (!maintainCase) string = string.replace(/[A-Z]+/g, lower)
	  return string.trim()
	    .replace(re, '')
	    .replace(emoji(), '')
	    .replace(whitespace, replacement)
	}


/***/ }),

/***/ 91:
/***/ (function(module, exports) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	  name: true,
	  length: true,
	  prototype: true,
	  caller: true,
	  callee: true,
	  arguments: true,
	  arity: true
	};
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	
	module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	
	        if (objectPrototype) {
	            var inheritedComponent = getPrototypeOf(sourceComponent);
	            if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	            }
	        }
	
	        var keys = getOwnPropertyNames(sourceComponent);
	
	        if (getOwnPropertySymbols) {
	            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                try { // Avoid failures from read-only properties
	                    defineProperty(targetComponent, key, descriptor);
	                } catch (e) {}
	            }
	        }
	
	        return targetComponent;
	    }
	
	    return targetComponent;
	};


/***/ }),

/***/ 429:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPHN2ZyB3aWR0aD0iMTc5MiIgaGVpZ2h0PSIxNzkyIiB2aWV3Qm94PSIwIDAgMTc5MiAxNzkyIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIGQ9Ik0xMzYzIDg3N2wtNzQyIDc0MnEtMTkgMTktNDUgMTl0LTQ1LTE5bC0xNjYtMTY2cS0xOS0xOS0xOS00NXQxOS00NWw1MzEtNTMxLTUzMS01MzFxLTE5LTE5LTE5LTQ1dDE5LTQ1bDE2Ni0xNjZxMTktMTkgNDUtMTl0NDUgMTlsNzQyIDc0MnExOSAxOSAxOSA0NXQtMTkgNDV6IiBmaWxsPSIjOTc5Nzk3Ii8+PC9zdmc+"

/***/ }),

/***/ 113:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPHN2ZyB3aWR0aD0iMTc5MiIgaGVpZ2h0PSIxNzkyIiB2aWV3Qm94PSIwIDAgMTc5MiAxNzkyIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIGQ9Ik0xNDA4IDkyOHYzMjBxMCAxMTktODQuNSAyMDMuNXQtMjAzLjUgODQuNWgtODMycS0xMTkgMC0yMDMuNS04NC41dC04NC41LTIwMy41di04MzJxMC0xMTkgODQuNS0yMDMuNXQyMDMuNS04NC41aDcwNHExNCAwIDIzIDl0OSAyM3Y2NHEwIDE0LTkgMjN0LTIzIDloLTcwNHEtNjYgMC0xMTMgNDd0LTQ3IDExM3Y4MzJxMCA2NiA0NyAxMTN0MTEzIDQ3aDgzMnE2NiAwIDExMy00N3Q0Ny0xMTN2LTMyMHEwLTE0IDktMjN0MjMtOWg2NHExNCAwIDIzIDl0OSAyM3ptMzg0LTg2NHY1MTJxMCAyNi0xOSA0NXQtNDUgMTktNDUtMTlsLTE3Ni0xNzYtNjUyIDY1MnEtMTAgMTAtMjMgMTB0LTIzLTEwbC0xMTQtMTE0cS0xMC0xMC0xMC0yM3QxMC0yM2w2NTItNjUyLTE3Ni0xNzZxLTE5LTE5LTE5LTQ1dDE5LTQ1IDQ1LTE5aDUxMnEyNiAwIDQ1IDE5dDE5IDQ1eiIgZmlsbD0iI2ZmZiIvPjwvc3ZnPg=="

/***/ }),

/***/ 114:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPHN2ZyB3aWR0aD0iMTc5MiIgaGVpZ2h0PSIxNzkyIiB2aWV3Qm94PSIwIDAgMTc5MiAxNzkyIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIGQ9Ik0xMzQzIDEydjI2NGgtMTU3cS04NiAwLTExNiAzNnQtMzAgMTA4djE4OWgyOTNsLTM5IDI5NmgtMjU0djc1OWgtMzA2di03NTloLTI1NXYtMjk2aDI1NXYtMjE4cTAtMTg2IDEwNC0yODguNXQyNzctMTAyLjVxMTQ3IDAgMjI4IDEyeiIgZmlsbD0iIzFCMjUzMyIvPjwvc3ZnPgo="

/***/ }),

/***/ 115:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPHN2ZyB3aWR0aD0iMTc5MiIgaGVpZ2h0PSIxNzkyIiB2aWV3Qm94PSIwIDAgMTc5MiAxNzkyIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIGQ9Ik00NzcgNjI1djk5MWgtMzMwdi05OTFoMzMwem0yMS0zMDZxMSA3My01MC41IDEyMnQtMTM1LjUgNDloLTJxLTgyIDAtMTMyLTQ5dC01MC0xMjJxMC03NCA1MS41LTEyMi41dDEzNC41LTQ4LjUgMTMzIDQ4LjUgNTEgMTIyLjV6bTExNjYgNzI5djU2OGgtMzI5di01MzBxMC0xMDUtNDAuNS0xNjQuNXQtMTI2LjUtNTkuNXEtNjMgMC0xMDUuNSAzNC41dC02My41IDg1LjVxLTExIDMwLTExIDgxdjU1M2gtMzI5cTItMzk5IDItNjQ3dC0xLTI5NmwtMS00OGgzMjl2MTQ0aC0ycTIwLTMyIDQxLTU2dDU2LjUtNTIgODctNDMuNSAxMTQuNS0xNS41cTE3MSAwIDI3NSAxMTMuNXQxMDQgMzMyLjV6IiBmaWxsPSIjMUIyNTMzIi8+PC9zdmc+"

/***/ }),

/***/ 116:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPHN2ZyB3aWR0aD0iMTc5MiIgaGVpZ2h0PSIxNzkyIiB2aWV3Qm94PSIwIDAgMTc5MiAxNzkyIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIGQ9Ik0xNjg0IDQwOHEtNjcgOTgtMTYyIDE2NyAxIDE0IDEgNDIgMCAxMzAtMzggMjU5LjV0LTExNS41IDI0OC41LTE4NC41IDIxMC41LTI1OCAxNDYtMzIzIDU0LjVxLTI3MSAwLTQ5Ni0xNDUgMzUgNCA3OCA0IDIyNSAwIDQwMS0xMzgtMTA1LTItMTg4LTY0LjV0LTExNC0xNTkuNXEzMyA1IDYxIDUgNDMgMCA4NS0xMS0xMTItMjMtMTg1LjUtMTExLjV0LTczLjUtMjA1LjV2LTRxNjggMzggMTQ2IDQxLTY2LTQ0LTEwNS0xMTV0LTM5LTE1NHEwLTg4IDQ0LTE2MyAxMjEgMTQ5IDI5NC41IDIzOC41dDM3MS41IDk5LjVxLTgtMzgtOC03NCAwLTEzNCA5NC41LTIyOC41dDIyOC41LTk0LjVxMTQwIDAgMjM2IDEwMiAxMDktMjEgMjA1LTc4LTM3IDExNS0xNDIgMTc4IDkzLTEwIDE4Ni01MHoiIGZpbGw9IiMxQjI1MzMiLz48L3N2Zz4="

/***/ }),

/***/ 47:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/intelllex-reversed-logo.9b8ea1e2.png";

/***/ }),

/***/ 66:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _intelllexReversedLogo = __webpack_require__(47);
	
	var _intelllexReversedLogo2 = _interopRequireDefault(_intelllexReversedLogo);
	
	var _facebook = __webpack_require__(114);
	
	var _facebook2 = _interopRequireDefault(_facebook);
	
	var _twitter = __webpack_require__(116);
	
	var _twitter2 = _interopRequireDefault(_twitter);
	
	var _linkedin = __webpack_require__(115);
	
	var _linkedin2 = _interopRequireDefault(_linkedin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Footer = function Footer() {
	  return _react2.default.createElement(
	    'footer',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'footer__flex-box' },
	      _react2.default.createElement(
	        'div',
	        { className: 'footer__logo' },
	        _react2.default.createElement('img', { src: _intelllexReversedLogo2.default })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'footer__content' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-12 col-md' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'a',
	                { className: 'link', href: 'https://intelllex.com/' },
	                'Products & Services'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'a',
	                { className: 'link', href: 'https://intelllex.com/company' },
	                'Meet the team'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-12 col-md' },
	            _react2.default.createElement(
	              'div',
	              { className: 'text-block' },
	              _react2.default.createElement(
	                'div',
	                { className: 'title-text' },
	                'Contact Us'
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                'For support issues: ',
	                _react2.default.createElement(
	                  'a',
	                  { href: 'mailto:support@intelllex.com' },
	                  'support@intelllex.com'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                'Contact sales: ',
	                _react2.default.createElement(
	                  'a',
	                  { href: 'mailto:contact@intelllex.com' },
	                  'contact@intelllex.com'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'text-block' },
	              _react2.default.createElement(
	                'div',
	                null,
	                '276A South Bridge Rd,'
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                'Singapore 058825'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-12 col-md' },
	            _react2.default.createElement(
	              'div',
	              { className: 'text-block' },
	              _react2.default.createElement(
	                'div',
	                { className: 'title-text' },
	                'Connect with us'
	              ),
	              _react2.default.createElement(
	                'a',
	                { href: 'https://www.facebook.com/intelllex/', target: '_blank', className: 'social-icon-link' },
	                _react2.default.createElement('img', { className: 'social-icon', src: _facebook2.default })
	              ),
	              _react2.default.createElement(
	                'a',
	                { href: 'https://sg.linkedin.com/company/intelllex', target: '_blank', className: 'social-icon-link' },
	                _react2.default.createElement('img', { className: 'social-icon', src: _linkedin2.default })
	              ),
	              _react2.default.createElement(
	                'a',
	                { href: 'https://twitter.com/intelllexhq', target: '_blank', className: 'social-icon-link' },
	                _react2.default.createElement('img', { className: 'social-icon', src: _twitter2.default })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'span',
	            { className: 'ie-brand' },
	            '\xA9 INTELLLEX'
	          ),
	          '\xA0\xA0',
	          _react2.default.createElement(
	            'a',
	            { href: 'https://intelllex.com/privacy', target: '_blank' },
	            'Privacy'
	          ),
	          '\xA0\xA0|\xA0\xA0',
	          _react2.default.createElement(
	            'a',
	            { href: 'https://intelllex.com/terms', target: '_blank' },
	            'Terms'
	          )
	        )
	      ),
	      _react2.default.createElement('div', { className: 'footer__logo' })
	    )
	  );
	};
	
	exports.default = Footer;
	module.exports = exports['default'];

/***/ }),

/***/ 67:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _intelllexReversedLogo = __webpack_require__(47);
	
	var _intelllexReversedLogo2 = _interopRequireDefault(_intelllexReversedLogo);
	
	var _externalLink = __webpack_require__(113);
	
	var _externalLink2 = _interopRequireDefault(_externalLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Header = function Header(_ref) {
	  var tall = _ref.tall;
	  return _react2.default.createElement(
	    'div',
	    { className: 'header' },
	    _react2.default.createElement(
	      'div',
	      { className: 'header-row' },
	      _react2.default.createElement(
	        'span',
	        { className: 'logo-group' },
	        _react2.default.createElement('img', { src: _intelllexReversedLogo2.default, className: 'logo' }),
	        _react2.default.createElement(
	          'span',
	          null,
	          'INTELLLEX'
	        )
	      ),
	      _react2.default.createElement(
	        'h3',
	        { className: 'support' },
	        'SUPPORT'
	      ),
	      _react2.default.createElement(
	        'a',
	        { href: 'https://intelllex.com', className: 'intlx-link' },
	        _react2.default.createElement('img', { src: _externalLink2.default }),
	        'Back to INTELLLEX'
	      )
	    ),
	    tall && _react2.default.createElement(
	      'h1',
	      { className: 'caption' },
	      'Get more out of INTELLLEX'
	    )
	  );
	};
	
	exports.default = Header;
	module.exports = exports['default'];

/***/ }),

/***/ 191:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(145);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _chevronRight = __webpack_require__(429);
	
	var _chevronRight2 = _interopRequireDefault(_chevronRight);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavBreadCrumb = function NavBreadCrumb(_ref) {
	  var currentRouteName = _ref.currentRouteName;
	  return _react2.default.createElement(
	    'div',
	    { className: 'breadcrumb' },
	    _react2.default.createElement(
	      _gatsbyLink2.default,
	      { to: '' },
	      'Support'
	    ),
	    _react2.default.createElement('img', { src: _chevronRight2.default, alt: '>', className: 'chevron-right' }),
	    _react2.default.createElement(
	      'span',
	      null,
	      currentRouteName
	    )
	  );
	};
	
	exports.default = NavBreadCrumb;
	module.exports = exports['default'];

/***/ }),

/***/ 68:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SectionLink = function (_PureComponent) {
	  _inherits(SectionLink, _PureComponent);
	
	  function SectionLink() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, SectionLink);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _PureComponent.call.apply(_PureComponent, [this].concat(args))), _this), _this.onClick = function () {
	      var el = document.getElementById(_this.props.scrollTo);
	      el && el.scrollIntoView();
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  SectionLink.prototype.render = function render() {
	    return _react2.default.createElement(
	      "div",
	      { className: "section-nav-item", onClick: this.onClick },
	      this.props.name
	    );
	  };
	
	  return SectionLink;
	}(_react.PureComponent);
	
	exports.default = SectionLink;
	module.exports = exports["default"];

/***/ }),

/***/ 192:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Header = __webpack_require__(67);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(66);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaqPostPageLayout = function FaqPostPageLayout(_ref) {
	  var children = _ref.children;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_Header2.default, null),
	    _react2.default.createElement(
	      'div',
	      { className: 'faq-post-page-container' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        children
	      )
	    ),
	    _react2.default.createElement(_Footer2.default, null)
	  );
	};
	
	exports.default = FaqPostPageLayout;
	module.exports = exports['default'];

/***/ }),

/***/ 196:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	exports.default = Template;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _githubSlugger = __webpack_require__(311);
	
	var _githubSlugger2 = _interopRequireDefault(_githubSlugger);
	
	var _FaqPostPageLayout = __webpack_require__(192);
	
	var _FaqPostPageLayout2 = _interopRequireDefault(_FaqPostPageLayout);
	
	var _NavBreadCrumb = __webpack_require__(191);
	
	var _NavBreadCrumb2 = _interopRequireDefault(_NavBreadCrumb);
	
	var _SectionLink = __webpack_require__(68);
	
	var _SectionLink2 = _interopRequireDefault(_SectionLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Template(_ref) {
	  var data = _ref.data;
	  var markdownRemark = data.markdownRemark;
	  var frontmatter = markdownRemark.frontmatter,
	      html = markdownRemark.html,
	      headings = markdownRemark.headings;
	
	  var h1s = headings.filter(function (x) {
	    return x.depth === 1;
	  });
	  var slugger = new _githubSlugger2.default();
	
	  return _react2.default.createElement(
	    _FaqPostPageLayout2.default,
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'row' },
	      _react2.default.createElement(_NavBreadCrumb2.default, { currentRouteName: frontmatter.title })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'row', id: 'faq-post' },
	      _react2.default.createElement(
	        'div',
	        { className: 'col-12 col-md-3 post-nav-container' },
	        _react2.default.createElement(
	          'div',
	          { className: 'nav-heading' },
	          'Sections:'
	        ),
	        h1s.map(function (h) {
	          var id = slugger.slug(h.value);
	          return _react2.default.createElement(_SectionLink2.default, { key: id, scrollTo: id, name: h.value });
	        })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col-12 col-md-9 post-content-container' },
	        _react2.default.createElement(
	          'div',
	          { className: 'title' },
	          frontmatter.title
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'date' },
	          'Updated on ',
	          frontmatter.date
	        ),
	        _react2.default.createElement('article', {
	          dangerouslySetInnerHTML: { __html: html }
	        })
	      )
	    )
	  );
	}
	
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-faq-post-template-js-c82bef27d2d50f3e84ea.js